import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { investmentPlans } from "../../../../data";
import { Link } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormModal from "./FormModal";
import FreshModal from "./FreshModal";

export default function Two() {
	const content = (
		<Box>
			{/* INVESTMENT PLANS */}
			<section className=" w-full  text-black  bg-white  mt-[1rem]">
				<section className="w-full flex flex-col text-center  gap-5 lg:flex-row justify-center  items-center  p-4  ">
					<motion.h5
						viewport={{ once: true }}
						animate={{ opacity: 0, y: 80 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 1.5 }}
						className="text-[1.5rem]  text-center  mx-auto  font-serif  tracking-wider p-[0.3rem] ">
						Initiate your earning process by selecting your most prefered plan
					</motion.h5>
					{/* <img src={choosepl} alt="experts" className="" /> */}
				</section>
				<motion.section
					viewport={{ once: true }}
					animate={{ opacity: 0, y: 50 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 1.5 }}
					className="w-[98%] mx-auto my-3        grid  gap-4   grid-cols-2 ">
					{investmentPlans.map((data) => (
						<div
							key={data.id}
							className=" w-full  md:w-[90%]  md:mx-auto min-h-full  bg-gray-100     flex flex-col    gap-3 p-1  justify-around  items-center ">
							<h3 className="text-[1.1rem] tracking-wide  font-bold  text-black">
								{data.name}{" "}
								<span className="text-[0.9rem]">{`(${data.botName})`}</span>
							</h3>
							{/* <h6>{data.botName}</h6> */}
							<motion.ul
								viewport={{ once: true }}
								animate={{ opacity: 0, x: 50 }}
								whileInView={{ opacity: 1, x: 0 }}
								transition={{ duration: 1.5 }}
								className=" min-w-full  h-full flex  gap-2 flex-col justify-around  p-[0.5rem]  border-2  border-gray-400 items-center">
								<li className="li-plan-style">
									<span className="plan-field-style">Captital back:</span>
									<span className="plan-value-style">{data.CB}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Withdrawal:</span>
									<span className="plan-value-style">Anytime</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Min Amount:</span>
									<span className="plan-value-style">${data.minAmount}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Max Amount:</span>
									<span className="plan-value-style">
										{" "}
										{data?.id === 7 ? "Unlimited" : "$" + data.maxAmount}
									</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Daily profit:</span>
									<span className="plan-value-style">%{data.ROI}</span>
								</li>
								<li className="li-plan-style">
									<span className="plan-field-style">Referal Commission:</span>
									<span className="plan-value-style">{data.RC}</span>
								</li>
							</motion.ul>
							<FreshModal
								minAmount={data.minAmount}
								maxAmount={data.maxAmount}
								plan={data.name}
								roi={data.ROI}
								planId={data.id}
								botName={data.botName}
							/>
							{/* <Link
								className="bg-gradient-to-r  px-[1rem]  py-[0.3rem]    text-center text-[1.1rem] tracking-wide  font-serif  bg-red-800  my-2   text-white shadow-inner shadow-gray-500"
								to="en/register">
								Choose Plan <KeyboardArrowRightIcon />
							</Link> */}
						</div>
					))}
				</motion.section>
			</section>
		</Box>
	);

	return content;
}
